<script lang="ts">
  import { storyblokEditable } from '@storyblok/svelte';
  import { PageSection } from '@athena-lib/Page';
  import type { TextPageSectionBlock } from '@storyblok-types';
  import clsx from 'clsx';
  import { containerAlignClasses, type Alignment } from './shared/page-section-utils';
  import PageSectionHeading from './shared/PageSectionHeading.svelte';

  let { blok }: { blok: TextPageSectionBlock } = $props();
</script>

<PageSection
  id={blok.elementId}
  action={storyblokEditable}
  actionArg={blok}
  ySpace={{ top: blok.topPadding ?? 'medium', bottom: blok.bottomPadding ?? 'medium' }}
  backgroundColor={blok.backgroundColor ?? 'light'}
>
  <div
    class={clsx(
      'flex',
      containerAlignClasses['desktop'][(blok.desktopAlignment as Alignment) ?? 'left'],
    )}
  >
    <div class={clsx(blok.headingFullWidth !== true && 'w-full max-w-text-max')}>
      <PageSectionHeading
        allowFullWidthHeading={blok.headingFullWidth}
        headingText={blok.headingText}
        headingTag={blok.headingTag}
        headingSize={blok.headingSize}
        description={blok.description}
        mobileAlignment={blok.mobileTextAlignment}
        desktopAlignment={blok.desktopTextAlignment}
        ctaButton={{
          text: blok.ctaButtonText,
          color: blok.ctaButtonColor,
          link: blok.ctaButtonLink,
        }}
      />
    </div>
  </div>
</PageSection>
